module.exports = __webpack_public_path__ + "img/85.3fcaa2ac.jpg";